import React from 'react';
import { Card, Collapse, message, Modal } from 'antd';
import { Switch, Select, Typography } from 'antd';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { channelAdminConfig } from '../skills_action';
import queryString from 'query-string';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import axios from 'axios';
import MemberSelect from '../../common/memberSelect';
const { Text, Paragraph } = Typography;
const { Option } = Select;
const { Panel } = Collapse;

class ChannelAdmins extends React.Component {
  constructor(props) {
    super();
    this.state = {
      channel_id: '',
      selectloading: false,
      switchloading: false,
      restriction: false,
      channelAdmins: false,
      currentChannel: false,
      isGridSharedChannel: false,
      defaultSelectedUsers: [],
      // disableSelect: false,
    };
  }

  componentDidMount() {
    const { commonChanneldata, currentChannelConfigs, userChannels } =
      this.props;
    const { channel_id, channelAdmins } = this.state;
    this.setState(
      {
        channel_id: queryString.parse(window.location.search).channel_id,
        parsedQueryString: queryString.parse(window.location.search),
      },
      () => {
        //checking if it's enterprice shared channel or not
        const channelFound = userChannels.find(
          (cha) => cha.id === this.state.channel_id
        );
        let isGridSharedChannel = false;
        if (
          channelFound &&
          channelFound.is_org_shared &&
          channelFound.enterprise_id
        ) {
          isGridSharedChannel = true;
          this.setState({ isGridSharedChannel: true });
          // axios.get(`/bot/api/${this.props.match.params.wId}/gridSharedChannelAdminsConfig/channel/${this.state.channel_id}`).then(res => {
          axios
            .get(
              `/bot/api/w/${this.props.match.params.wId}/channelConfig/gridSharedChannelAdminsConfig/channel/${this.state.channel_id}`
            )
            .then((res) => {
              if (res.data._id) {
                this.setState({
                  currentChannel: res.data,
                  restriction: res.data.restrict_channel_config,
                  channelAdmins: res.data.channel_admins.map((u) => {
                    if (u && u.user_id) {
                      return u.user_id;
                    } else {
                      return u;
                    }
                  }),
                  defaultSelectedUsers: res.data.channel_admins,
                });
              }
            });
        } else {
          const currentChannelFound = commonChanneldata.find(
            (cha) => cha.channel_id == this.state.channel_id
          );
          currentChannelFound &&
            this.setState({
              currentChannel: currentChannelFound,
              restriction: currentChannelFound.restrict_channel_config,
              channelAdmins: currentChannelFound.channel_admins.map((u) => {
                if (u && u.user_id) {
                  return u.user_id;
                } else {
                  return u;
                }
              }),
              defaultSelectedUsers: currentChannelFound.channel_admins,
            });
        }
      }
    );

    // if (currentChannelFound) this.checkSelectDisableConditions(currentChannelFound);
    // else this.setState({ disableSelect: true });
  }

  handleSwitch = (checked) => {
    const { channelAdmins, currentChannel } = this.state;

    this.setState({ switchloading: true });
    if (!checked) {
      Modal.confirm({
        title: 'Disable channel restrictions?',
        icon: <ExclamationCircleOutlined />,
        content: (
          <p>
            Are you sure your want to remove channel restrictions? This action
            will
            <ul>
              <li>Remove current channel administrators</li>
              <li>Allow anyone to configure this channel</li>
            </ul>
          </p>
        ),
        onOk: () => this.handleSwitchAction(),
        onCancel: () => this.setState({ switchloading: false }),
      });
    } else this.handleSwitchAction();
  };

  handleSwitchAction = () => {
    const { restriction, channel_id, currentChannel } = this.state;
    const { user_now } = this.props;
    this.setState({ switchloading: true });

    let data = {
      restrict_channel_config: !restriction,
      channel_type: this.state.parsedQueryString.channel_type,
    };

    //when disabling restriction, we are removing all admins
    if (restriction) {
      data.channel_admins = [];
    }

    if (!currentChannel || currentChannel.channel_admins.length == 0) {
      data.channel_admins = [user_now._id];

      this.setState({ defaultSelectedUsers: [user_now] });
    }

    data.channel = this.props.channel;
    this.props
      .channelAdminConfig(
        this.props.match.params.wId,
        this.props.match.params.skill_id,
        queryString.parse(window.location.search).channel_id,
        data,
        this.state.isGridSharedChannel
      )
      .then((res) => {
        if (res.data.success) {
          // this.checkSelectDisableConditions(res.data.channelCommonData);
          if (res.data.channelCommonData) {
            this.setState({
              switchloading: false,
              restriction: res.data.channelCommonData.restrict_channel_config,
              channelAdmins: res.data.channelCommonData.channel_admins.map(
                (u) => {
                  if (u && u.user_id) {
                    return u.user_id;
                  } else {
                    return u;
                  }
                }
              ),
              currentChannel: res.data.channelCommonData,
              defaultSelectedUsers: res.data.channelCommonData.channel_admins,
            });
          } else {
            this.setState({
              switchloading: false,
              restriction: false,
              channelAdmins: false,
              currentChannel: false,
            });
          }
        }
      });
  };

  handleSelect = (value) => {
    const { user_now, isWorkspaceAdimin, isChannelAdmin } = this.props;
    let channelAdmins = [...this.state.channelAdmins];
    channelAdmins.push(value);
    // this.setState({channelAdmins})
    this.updateChannelAdmins(channelAdmins);
  };

  handleDeSelect = (value) => {
    const { user_now, isWorkspaceAdimin } = this.props;
    const { channelAdmins, currentChannel } = this.state;
    const isChannelAdmin = channelAdmins.some(
      (val) => val.toString() === user_now._id.toString()
    );
    if (isChannelAdmin || isWorkspaceAdimin) {
      if (value == user_now._id) {
        if (channelAdmins.length === 1) {
          Modal.confirm({
            title: (
              <div>
                {' '}
                <div>
                  If you remove last administrator in channel restrictions,
                </div>{' '}
                This will disable channel configuration restrictions in this
                channel. If you confirm then any user will be able to change
                preferences for this channel. Are you sure?,
              </div>
            ),
            okText: 'Yes',
            cancelText: 'No',
            maskClosable: true,
            onOk: () => this.updateChannelAdmins([], true),
            okType: 'danger',
          });
        } else {
          let ChannelAdmins = [...channelAdmins];
          let index = ChannelAdmins.findIndex(
            (id) => id.toString() === value.toString()
          );
          ChannelAdmins.splice(index, 1);
          if (!isWorkspaceAdimin) {
            Modal.confirm({
              title:
                'Removing yourself as a channel admin will result in losing access to this channel configuration. Are you sure ',
              okText: 'Yes',
              cancelText: 'No',
              maskClosable: true,
              onOk: () => this.updateChannelAdmins(ChannelAdmins, false, true),
              okType: 'primary',
            });
          } else {
            this.updateChannelAdmins(ChannelAdmins);
          }
        }
      } else {
        let ChannelAdmins = [...channelAdmins];
        let index = ChannelAdmins.findIndex(
          (id) => id.toString() === value.toString()
        );
        ChannelAdmins.splice(index, 1);
        if (ChannelAdmins.length === 0) {
          return Modal.confirm({
            title: (
              <div>
                <div>
                  If you remove last administrator in channel restrictions,
                </div>{' '}
                This will disable channel configuration restrictions in this
                channel. If you confirm then any user will be able to change
                preferences for this channel. Are you sure?,
              </div>
            ),
            okText: 'Yes',
            cancelText: 'No',
            maskClosable: true,
            onOk: () => this.updateChannelAdmins(ChannelAdmins, true),
            okType: 'danger',
          });
        }
        this.updateChannelAdmins(ChannelAdmins);
      }
    }
  };

  updateChannelAdmins = (
    channelAdmins,
    disableRestriction = false,
    redirectToChannelConfigurations = false
  ) => {
    const { channel_id } = this.state;

    this.setState({ selectloading: true });
    const data = {
      channel_admins: channelAdmins,
      channel: this.props.channel,
    };
    if (disableRestriction) {
      data.restrict_channel_config = false;
    }
    this.props
      .channelAdminConfig(
        this.props.match.params.wId,
        this.props.match.params.skill_id,
        queryString.parse(window.location.search).channel_id,
        data,
        this.state.isGridSharedChannel
      )
      .then((res) => {
        if (res.data.success) {
          // this.checkSelectDisableConditions(res.data.channelCommonData);
          this.setState({
            selectloading: false,
            restriction: res.data.channelCommonData.restrict_channel_config,
            channelAdmins: res.data.channelCommonData.channel_admins.map((u) =>
              u.user_id ? u.user_id : u
            ),
            currentChannel: res.data.channelCommonData,
            defaultSelectedUsers: res.data.channelCommonData.channel_admins,
          });
          if (redirectToChannelConfigurations) {
            this.props.history.push(
              `/${this.props.match.params.wId}/skills/${
                this.props.match.params.skill_id
              }${
                this.props.match.params.sub_skill
                  ? '/' + this.props.match.params.sub_skill
                  : ''
              }?view=channel_preferences`
            );
          }
          // message.success("Channel admins updated successfully");
        }
      });
  };

  render() {
    const { members, commonChanneldata, isWorkspaceAdimin } = this.props;
    const {
      channel_id,
      selectloading,
      switchloading,
      restriction,
      channelAdmins,
      currentChannel,
      disableSelect,
      defaultSelectedUsers,
    } = this.state;

    return (
      // <Collapse>
      <Card
        key={'1'}
        title='Restrict Channel configuration'
        extra={
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <Switch
              loading={switchloading}
              checked={restriction}
              onClick={this.handleSwitch}
            />
          </div>
        }
      >
        <Paragraph type='secondary'>
          Allow only channel adminstrators to configure this channel
        </Paragraph>
        <div className='Jira_preference_personal_default_type'>
          <Text type='secondary'>Channel Admins</Text>
        </div>
        <MemberSelect
          title='Channel Admins'
          style={{ width: '100%' }}
          wId={this.props.match.params.wId}
          mode='multiple'
          // onChange={this.handleSelect}
          onSelect={this.handleSelect}
          onDeselect={this.handleDeSelect}
          value={channelAdmins ? channelAdmins : []}
          disabled={
            currentChannel && currentChannel.restrict_channel_config
              ? false
              : true
          }
          defaultUsers={defaultSelectedUsers}
        />

        {/*
       // <Select
        //   title='Channel Admins'
        //   style={{ width: '100%' }}
        //   mode='multiple'
        //   // onChange={this.handleSelect}
        //   onSelect={this.handleSelect}
        //   onDeselect={this.handleDeSelect}
        //   value={channelAdmins ? channelAdmins : []}
        //   disabled={
        //     currentChannel && currentChannel.restrict_channel_config
        //       ? false
        //       : true
        //   }
        //   filterOption={(input, option) =>
        //     option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
        //     0
        //   }
        //   loading={selectloading}
        // >
        //   {members.map((mem) => {
        //     return (
        //       <Option
        //         key={mem.user_id._id}
        //         value={mem.user_id._id}
        //         label={mem.user_id._id}
        //       >
        //         {mem.user_id.displayName || mem.user_id.name}
        //       </Option>
        //     );
        //   })}
        // </Select>
  <Button
          onClick={this.handleSave}
          disabled={currentChannel && currentChannel.restrict_channel_config ? false : true}
          style={{ margin: "-10px auto 10px auto" }}
        >
          Save
        </Button> */}
        {/* <Alert showIcon description='Allow only channel adminstrators to configure this channel' /> */}
      </Card>
      // </Collapse>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    jiraChannelConfigs: state.skills.getJiraConfigs,

    commonChanneldata: state.skills.commonChanneldata,
    user_now: state.common_reducer.user,
  };
};

export default withRouter(
  connect(mapStateToProps, { channelAdminConfig })(ChannelAdmins)
);
